import React from 'react';
import {InputAdornment} from '@mui/material';
import {Controller, useForm} from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
import TextInput from '@components/form/text-input/text-input/TextInput';

interface SearchProps {
  handleChangeText: any;
  fieldName?: string;
  submitLoading?: boolean;
  placeHolder?: string;
  searchQuery?: string;
}

const Search = (props: SearchProps): React.ReactElement => {
  const {fieldName, handleChangeText, placeHolder, searchQuery} = props;
  const {control} = useForm({mode: 'onBlur'});

  return (
    <Controller
      key={fieldName}
      name={fieldName || ''}
      control={control}
      render={({field, fieldState: {error}}) => (
        <TextInput
          size="small"
          sx={{
            '& legend': {display: 'none'},
            '& fieldset': {top: 0},
            backgroundColor: 'white'
          }}
          variant="outlined"
          name={''}
          type="text"
          placeholder={placeHolder}
          defaultValue={''}
          value={searchQuery}
          field={field}
          fullWidth={true}
          onChange={handleChangeText}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      )}
    />
  );
};

export default Search;
